import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
} from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideToastr, ToastrModule } from 'ngx-toastr';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { loaderInterceptor } from './core/interceptors/loader.interceptor';
import { NgxSpinnerService } from 'ngx-spinner';
// import { HashLocationStrategy, LocationStrategy } from '@angular/common';

// Function to show spinner immediately on app initialization
export function initializeSpinner(spinner: NgxSpinnerService) {
  return () => {
    // Show spinner immediately when app initializes
    // Use setTimeout to ensure it happens as early as possible
    setTimeout(() => {
      spinner.show();
    }, 0);
    return Promise.resolve();
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    // hashLocationStrategy
    // {
    //   provide: LocationStrategy,
    //   useClass: HashLocationStrategy,
    // },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeSpinner,
      deps: [NgxSpinnerService],
      multi: true,
    },
    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
    ),
    // provideClientHydration(),
    provideNativeDateAdapter(),
    provideToastr(),
    provideAnimations(),
    provideHttpClient(
      withFetch(),
      withInterceptors([authInterceptor, loaderInterceptor]),
    ),
  ],
};
